export default __webpack_public_path__ + "static/media/sports03.147a7cf8.png";